import 'babel-polyfill'
import Vue from 'vue'
import App from './components/App'
import store from './store'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueSemantic from 'croud-vue-semantic'
import {i18n} from './plugins'
import VeeValidate from 'vee-validate'
import VeeDa from 'vee-validate/dist/locale/da'
import VeeEn from 'vee-validate/dist/locale/en'
import IdleVue from 'idle-vue'
import VueEvents from 'vue-events'
import accounting from 'accounting'
import moment from 'moment'
import Paginate from 'vuejs-paginate'

import './components'
import './bootstrap'
import 'semantic-ui-css/semantic.min.css'
import 'semantic-ui-css/semantic.min.js'
import './assets/app.scss'
import './assets/plugins/hopscotch.scss'
import './assets/plugins/fullcalendar.scss'
import './plugins/fullstory'

import insp from './insp.js';

if (process.env.NODE_ENV === 'production') {
  insp();
}

const eventsHub = new Vue()

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  idleTime: 1800000,
  store
})


Vue.component('paginate', Paginate);

Vue.use(VueEvents)
Vue.use(VueAxios, axios)
Vue.use(VueSemantic)
if (!window.localStorage.language) {
  window.localStorage.language = navigator.language || 'da';
}
Vue.use(VeeValidate, {
  locale: window.localStorage.language,
  dictionary: {
    da: VeeDa,
    da_DK: VeeDa,
    en: VeeEn,
    en_US: VeeEn
  }
})

Vue.axios.defaults.baseURL = process.env.API_URL

Vue.config.productionTip = false

Vue.router = router

// Vue Auth
Vue.use(require('@websanova/vue-auth'), {
  auth: require('@websanova/vue-auth/drivers/auth/bearer.js'),
  http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),

  rolesVar: 'role_id',

  registerData: {
    url: 'external-registration',
    redirect: false,
    makeRequest: true
  },

  loginData: {
    url: 'authenticate',
    redirect: '/dashboard'
  },

  logoutData: {
    url: 'invalidate',
    method: 'POST',
    redirect: '/login',
    makeRequest: true
  },

  fetchData: {
    url: 'users/me',
    method: 'GET',
    enabled: true
  },

  refreshData: {
    url: 'refresh',
    method: 'POST',
    enabled: true,
    interval: 19
  },

  tokenStore: ['cookie', 'localStorage'],

  parseUserData: data => {
    return data
  },

  tokenExpired: () => {
    return false
  }
})

let component = App

component.router = Vue.router

Vue.mixin({
  filters: {
    money(value, currency = 'DKK ', minFrac = 2) {
      return accounting.formatMoney(value, currency, minFrac)
    },

    date(value, format = 'Do MMM, YYYY') {
      return moment(value).format(format)
    }
  },
  methods: {
    safeObjectGet(obj, path) {
      if (!obj) return null
      if (!path) return obj

      const splitPath = path.split('.')
      const nextObj = obj[splitPath[0]]

      if (nextObj) {
        if (splitPath.length === 1) return nextObj

        const remainingPath = splitPath.slice(1).join('.')
        return this.safeObjectGet(nextObj, remainingPath)
      }

      return null
    }
  }
})

new Vue({
  el: '#app',
  i18n,
  store,
  ...component
})



// WEBPACK FOOTER //
// ./src/main.js